import { observer } from 'mobx-react';
import classnames from 'classnames';

import style from './EntryConfirmPopup.module.scss';

import { Badge } from '@components/Badge/Badge';
import { Button, ButtonModifiers, ButtonTheme } from '@components/Button';
import { Preloader, PreloaderModifiers } from '@components/Preloader/Preloader';
import { EntryPageTestAttributes } from 'chaika-test-attributes';

import '@components/mixins/commonStyles.scss';
import { translate } from '@chaika/i18n/helper';
import { store } from '@store';

interface EntryConfirmPopupProps {
    title: string;
    description: string;
    withBadge?: boolean;
    isLoading?: boolean;
    confirmText?: string;
    cancelText?: string;
    onConfirm?(): void;
    onCancel?(): void;
}

export const EntryConfirmPopup = observer(
    ({
        title,
        description,
        withBadge = false,
        isLoading = false,
        confirmText,
        cancelText,
        onConfirm,
        onCancel,
    }: EntryConfirmPopupProps) => {
        const {
            viewPort: { isMobileSize },
        } = store;

        const buttonModifiers = isMobileSize ? [ButtonModifiers.Small] : undefined;

        return (
            <div className={style.root}>
                {withBadge && <Badge text={translate('attention')} />}
                <div className={classnames(['font_h2', style.title])}>{title}</div>
                <div className={classnames(['font_body16Black', style.description])}>{description}</div>
                <div className={style.actionButtons}>
                    {onCancel && (
                        <Button
                            modifiers={buttonModifiers}
                            dataTest={EntryPageTestAttributes.EntryPopupCloseButton}
                            label={cancelText ?? translate('returnToEntry')}
                            disabled={isLoading}
                            onClick={onCancel}
                        />
                    )}
                    {isLoading ? <Preloader modifiers={[PreloaderModifiers.Small]} /> : null}
                    {onConfirm && (
                        <Button
                            theme={ButtonTheme.Secondary}
                            modifiers={buttonModifiers}
                            dataTest={EntryPageTestAttributes.EntryPopupConfirmButton}
                            label={confirmText ?? translate('continue')}
                            disabled={isLoading}
                            onClick={onConfirm}
                        />
                    )}
                </div>
            </div>
        );
    },
);
